import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const PlayIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4.92427V15.0757C6 15.7967 6.77731 16.2389 7.38279 15.8631L15.565 10.7879C16.145 10.4279 16.145 9.57214 15.565 9.21305L7.38279 4.13685C6.77731 3.76114 6 4.20332 6 4.92427Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
